import { Component, inject, model, OnInit, TemplateRef, ViewChild } from '@angular/core';
import * as uuid from 'uuid';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastTypes } from '@core/enums/toast-types';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgTemplateOutlet } from '@angular/common';
import { ToastService } from '@core/services/toast.service';

export class ToastOptions {
  id?: string = uuid.v4();
  class?: string;
  autohide?: boolean;
  duration?: number;
  type?: ToastTypes;
  title?: string;
  message?: string;
  onHide?: () => void;
  template?: TemplateRef<any>;

  constructor(args?: ToastOptions) {
    this.id = args?.id || this.id;
    this.class = args?.class || '';
    this.autohide = args?.autohide !== undefined ? args?.autohide : true;
    this.duration = args?.duration || 5000;
    this.type = args?.type || ToastTypes.standard;
    this.title = args?.title || '';
    this.message = args?.message || '';
    this.onHide = args?.onHide;
    this.template = args?.template;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-toast',
  imports: [NgbToast, NgTemplateOutlet],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent implements OnInit {
  @ViewChild('standard', { static: true }) standardTemplate?: TemplateRef<any>;
  @ViewChild('info', { static: true }) infoTemplate?: TemplateRef<any>;
  @ViewChild('error', { static: true }) errorTemplate?: TemplateRef<any>;

  private readonly translate = inject(TranslateService);
  protected translations = this.translate.instant('toast');
  protected toastService = inject(ToastService);

  options = model(new ToastOptions());

  ngOnInit(): void {
    switch (this.options().type) {
      case ToastTypes.success:
        {
          this.options().template = this.standardTemplate;
        }
        break;
      case ToastTypes.warning:
        {
          this.options().template = this.standardTemplate;
        }
        break;
      case ToastTypes.error:
        {
          this.options().template = this.errorTemplate;
        }
        break;
      case ToastTypes.standard:
      default:
        {
          this.options().template = this.standardTemplate;
        }
        break;
    }
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('toast');
    });
  }
}
